import { useEffect } from 'react';
import { metrics } from '@atlassian/browser-metrics';
import {
	LIST_DRAG_AND_DROP,
	LIST_RESIZE_DRAG_AND_DROP,
	CHILD_LIST_DRAG_AND_DROP,
} from '@atlassian/timeline-table/common/constants';
import {
	type InteractionMetricType,
	CHART_BAR_RESIZE,
	DEPENDENCY_DRAG_AND_DROP,
} from '@atlassian/jira-software-roadmap-utils/src/utils/metrics/common/constants.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PerformanceMetric = any;

const camelCaseToKebabCase = (str: string) =>
	str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

export const dndMetrics: Partial<Record<InteractionMetricType, PerformanceMetric>> = {
	[CHART_BAR_RESIZE]: metrics.interaction({
		key: `jwm.timeline.${camelCaseToKebabCase(CHART_BAR_RESIZE)}`,
	}),
	[LIST_RESIZE_DRAG_AND_DROP]: metrics.interaction({
		key: `jwm.timeline.${camelCaseToKebabCase(LIST_RESIZE_DRAG_AND_DROP)}`,
	}),
	[LIST_DRAG_AND_DROP]: metrics.interaction({
		key: `jwm.timeline.${camelCaseToKebabCase(LIST_DRAG_AND_DROP)}`,
	}),
	[CHILD_LIST_DRAG_AND_DROP]: metrics.interaction({
		key: `jwm.timeline.${camelCaseToKebabCase(CHILD_LIST_DRAG_AND_DROP)}`,
	}),
	[DEPENDENCY_DRAG_AND_DROP]: metrics.interaction({
		key: `jwm.timeline.${camelCaseToKebabCase(DEPENDENCY_DRAG_AND_DROP)}`,
	}),
};

type Props<T> = {
	isDragging: boolean;
	metricType: T;
	extraProps?: {
		[key: string]: boolean;
	};
};

export const DndLongTaskMetric = <T extends InteractionMetricType>({
	isDragging,
	metricType,
}: Props<T>) => {
	useEffect(() => {
		if (!dndMetrics[metricType]) {
			return;
		}

		if (isDragging) {
			dndMetrics[metricType].start();
		} else {
			dndMetrics[metricType].stop({
				stopTime: performance.now(),
			});
		}
	}, [isDragging, metricType]);

	return null;
};
